import React, { Fragment, useCallback, useState, useEffect } from "react";
import { 
    Card,
    CardBody,
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    Button,
    FormGroup,
    Label
} from 'reactstrap';

import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import Select from 'react-select';
import api from '../../../../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../../Context/Auth/AuthContext';
import DatePicker from 'react-datepicker';
import GiftStatuses from '../../../../../enums/GiftStatuses';
import { completedColor } from '../../../../../config/calendar';
import ModalEditCallLogFromEvent from '../../../../../Layout/AppMain/ModalEditCallLogFromEvent';

const localizer = momentLocalizer(moment);

export default function GiftsCalendar(props) {
    const { receivers, setTriggerLogCall } = props;
    const { toggleLoading, currentGroup, setGlobalGift, globalUpdate, setGlobalUpdate, authenticated } = useAuth();

    const options = () => {
        let options = [];
        // eslint-disable-next-line
        if (receivers) {
            receivers.map((receiver) => {
                options.push(
                    {
                        value: receiver.id,
                        label: receiver.name
                    }
                )
                return receiver;
            });
        }

        options.push({
            value: '',
            label: 'All'
        });
        
        return options;
    }

    const [events, setEvents] = useState([]);    
    const [originalEvents, setOriginalEvents] = useState([]);
    const [targetEvent, setTargetEvent] = useState();
    const [currentReceiver, setCurrentReceiver] = useState({});
    const [editReceiver, setEditReceiver] = useState(null);
    const [isEnabledEditCallLog, setIsEnabledCallLog] = useState();
    const [currentCallLogs, setCurrentCallLogs] = useState();

    const [modalTargetEvent, setModalTargetEvent] = useState(false);
    const toggleModalTargetEvent = useCallback(() => {
        setModalTargetEvent(!modalTargetEvent);
    }, [setModalTargetEvent, modalTargetEvent]);

    const [modalEdit, setModalEdit] = useState(false);
    const toggleModalEdit = useCallback(() => {
        setModalEdit(!modalEdit);
    }, [setModalEdit, modalEdit]);

    const [modalRemove, setModalRemove] = useState(false);
    const toggleModalRemove = useCallback(() => {
        setModalRemove(!modalRemove);
    }, [setModalRemove, modalRemove]);

    const [modalEditLog, setModalEditLog] = useState(false);
    const toggleModalEditLog = useCallback(() => {
        setModalEditLog(!modalEditLog);
    }, [setModalEditLog, modalEditLog]);

    const convertLabelDate = useCallback((system_date) => {
        if (system_date) {
            const month = parseInt(system_date.substring(4,6)) - 1;
            const date = new Date(
                system_date.substring(0,4),
                month,
                system_date.substring(6,8),
                system_date.substring(8,10),
                system_date.substring(10,12),
                0
            );
            return date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
        }
        return '';
    }, []);

    const getGifts = useCallback(() => {
        const convertDate = (system_date) => {
            if (system_date) {
                const month = parseInt(system_date.substring(4,6)) - 1;
                const date = new Date(
                    system_date.substring(0,4),
                    month,
                    system_date.substring(6,8),
                    system_date.substring(8,10),
                    system_date.substring(10,12),
                    0
                );
                return date;
            }
            return null;
        }

        const userInfo = () => {
            if (authenticated.user) {
                return authenticated.user;
            } else {
                return authenticated;
            }
        }

        setOriginalEvents([]);
        setEvents([]);
        toggleLoading(true);
        api.post(`/ro.team.listScheduleGiftsForGiver/${currentGroup.id}`, {
            giverId: userInfo().id
        })
            .then((response) => {
                const events_remote = response.data;
                if (events_remote && events_remote.length > 0) {
                    const calendar_events = [];
                    setOriginalEvents(events_remote);
                    events_remote.map((event, index) => {
                        calendar_events.push({
                            id: event.id,
                            title: `${convertLabelDate(event.date)} ${event.receiver.name}`,
                            start: convertDate(event.date),
                            end: convertDate(event.date),
                            color: (event.status === GiftStatuses.COMPLETED) ? completedColor : undefined
                        });
                        return event;
                    });
                    setEvents(calendar_events);
                }
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [currentGroup, toggleLoading, authenticated, convertLabelDate]);

    const changeReceiver = useCallback((event) => {
        const currentReceiverId = event.value;
        const currenReceiverName = event.label;

        const convertDate = (system_date) => {
            if (system_date) {
                const month = parseInt(system_date.substring(4,6)) - 1;
                const date = new Date(
                    system_date.substring(0,4),
                    month,
                    system_date.substring(6,8),
                    system_date.substring(8,10),
                    system_date.substring(10,12),
                    0
                );
                return date;
            }
            return null;
        }

        const userInfo = () => {
            if (authenticated.user) {
                return authenticated.user;
            } else {
                return authenticated;
            }
        }

        if (currentReceiverId) {
            setCurrentReceiver({value:event.value, label: event.label});
            setOriginalEvents([]);
            setEvents([]);
            toggleLoading(true);
            api.post(`/ro.team.listScheduleGiftsForReceiver/${currentGroup.id}`, {
                receiverId: currentReceiverId,
                giverId: userInfo().id
            })
                .then((response) => {
                    const events_remote = response.data;
                    if (events_remote && events_remote.length > 0) {
                        const calendar_events = [];
                        setOriginalEvents(events_remote);
                        events_remote.map((event) => {
                            calendar_events.push({
                                id: event.id,
                                title: `${convertLabelDate(event.date)} Call to ${currenReceiverName}`,
                                start: convertDate(event.date),
                                end: convertDate(event.date),
                                color: (event.status === GiftStatuses.COMPLETED) ? completedColor : undefined
                            });
                            return event;
                        });
                        setEvents(calendar_events);
                    }
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                })
                .finally(() => {
                    toggleLoading(false);
                });
        } else {
            getGifts();
        }
    }, [toggleLoading, currentGroup, setEvents, getGifts, setCurrentReceiver, authenticated, convertLabelDate]);

    const setEnabledCallLog = useCallback(async(targetEvent) => {
        const result = await api.post(`/ro.team.listLogGiftByGiftId/${currentGroup.id}`, {
            giftId: targetEvent.id
        });

        if (result.data.length > 0) {
            setCurrentCallLogs(result.data);
            setIsEnabledCallLog(true);
            return true;
        }
        setCurrentCallLogs([]);
        setIsEnabledCallLog(false);
    }, [currentGroup, setIsEnabledCallLog, setCurrentCallLogs]);

    const onSelectEvent = useCallback((event) => {
        if (event.id) {
            let target_event = null;
            originalEvents.map((e) => {
                if (e.id === event.id) {
                    target_event = e;
                }
                return false;
            });            

            if (target_event) {
                setTargetEvent(target_event);
                setEnabledCallLog(target_event);
                toggleModalTargetEvent();
            }
        }
    }, [originalEvents, setTargetEvent, toggleModalTargetEvent, setEnabledCallLog]);

    const convertDateFront = (date) => {
        const month = parseInt(date.substring(4,6)) - 1;
        const dateObj = new Date(
            date.substring(0,4),
            month,
            date.substring(6,8),
            date.substring(8,10),
            date.substring(10,12),
            0
        );
        const hour = dateObj.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
        return `${date.substring(0,4)}/${date.substring(4,6)}/${date.substring(6,8)} 
        ${hour}`;
    };

    useEffect(() => {
        if (globalUpdate.scheduledGifts) {
            changeReceiver(currentReceiver);
            setGlobalUpdate({...globalUpdate, scheduledGifts: false});
        } else {
            if (JSON.stringify(currentReceiver) === '{}') {
                getGifts();
            }
        }
    }, [getGifts, globalUpdate, setGlobalUpdate, changeReceiver, currentReceiver]);

    useEffect(() => {
        if (globalUpdate.toggleModalTargetEvent) {
            toggleModalTargetEvent();
            document.body.classList.remove('modal-open');
            setGlobalUpdate({...globalUpdate, toggleModalTargetEvent: false});
        }
    }, [globalUpdate, setGlobalUpdate, toggleModalTargetEvent]);

    const editEvent = useCallback(async () => {
        toggleLoading(true);

        if (editReceiver === null || editReceiver === targetEvent.receiver.id) {
            // Only changes the event
            api.post(`/ro.team.modifyScheduleGift/${targetEvent.id}`, {
                date: moment(targetEvent.editDate).format('YMMDDHHmm'),
                receiverId: targetEvent.receiver.id,
                groupId: currentGroup.id
            })
                .then(() => {
                    toggleModalEdit();
                    toggleModalTargetEvent();
                    document.body.classList.remove('modal-open');
                    setTargetEvent();
                    changeReceiver(currentReceiver);
                    toast.success('Event edited!');
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                })
                .finally(() => {
                    toggleLoading(false);
                });
        } else {
            // Changes the receiver: delete and create a new Event
            try {
                // Deleting old event
                await api.delete(`/ro.team.deleteScheduleGift/${targetEvent.id}`, {
                    data: {
                        receiverId: targetEvent.receiver.id,
                        groupId: currentGroup.id
                    }
                });
                // Creating a new one
                await api.post(`/ro.team.insertScheduleGift`, {
                    receiverId: editReceiver,
                    date: moment(targetEvent.editDate).format('YMMDDHHmm'),
                    groupId: currentGroup.id,
                });
                
                toggleLoading(false);
                toggleModalEdit();
                toggleModalTargetEvent();
                document.body.classList.remove('modal-open');
                setTargetEvent();
                changeReceiver(currentReceiver);
                setEditReceiver(null);
                toast.success('Event edited!');
            } catch(err) {
                toast.error('An error ocurred. Try again!');
            }
        }
    }, [toggleModalEdit, toggleModalTargetEvent, targetEvent, currentGroup, toggleLoading, setTargetEvent, changeReceiver, currentReceiver, editReceiver, setEditReceiver]);

    const removeEvent = useCallback(() => {
        toggleLoading(true);

        api.delete(`/ro.team.deleteScheduleGift/${targetEvent.id}`, {
            data: {
                receiverId: targetEvent.receiver.id,
                groupId: currentGroup.id
            }
        })
            .then(() => {
                toggleModalTargetEvent();
                toggleModalRemove();
                document.body.classList.remove('modal-open');
                setTargetEvent();
                changeReceiver(currentReceiver);
                toast.success('Event removed!');
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
        
    }, [toggleModalRemove, toggleModalTargetEvent, targetEvent, currentGroup, setTargetEvent, changeReceiver, currentReceiver, toggleLoading]);

    const convertDateJavascript = useCallback((system_date) => {
        if (system_date) {
            const month = parseInt(system_date.substring(4,6)) - 1;
            const date = new Date(
                system_date.substring(0,4),
                month,
                system_date.substring(6,8),
                system_date.substring(8,10),
                system_date.substring(10,12),
                0
            );
            return date;
        }
        return null;
    }, []);

    const toggleEditDate = useCallback((date) => {
        setTargetEvent({
            ...targetEvent,
            editDate: date
        })
    }, [targetEvent, setTargetEvent]);

    const toggleModalEditMiddle = useCallback(() => {
        setEditReceiver(null);
        setTargetEvent({
            ...targetEvent,
            editDate: convertDateJavascript(targetEvent.date)
        });
        toggleModalEdit();
    }, [setTargetEvent, targetEvent, convertDateJavascript, toggleModalEdit]);

    return (
        <Fragment>
            <Card className="mb-3">
                <CardBody>
                    <Row className="mb-4">
                        <Col lg="12">
                            <Select
                                options={options()}
                                placeholder="Select a Senior"
                                onChange={changeReceiver}
                                className="z-index-10"
                                defaultValue={{ value: '', label: 'All' }}
                            />
                        </Col>
                    </Row>
                    <Calendar
                        localizer={localizer}
                        events={events}
                        startAccessor="start"
                        endAccessor="end"
                        onSelectEvent={onSelectEvent}
                        views={['month', 'day', 'agenda']}
                        eventPropGetter={event => {
                            if (event.color && event.color !== undefined) {
                                return { style: { backgroundColor: event.color } };
                            }
                        }}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={modalTargetEvent} toggle={toggleModalTargetEvent}>
                <ModalHeader toggle={toggleModalTargetEvent}>
                    Event Details
                </ModalHeader>
                <ModalBody>
                    {targetEvent && (
                        <Fragment>
                            <p><b>Senior</b></p>
                            <p>
                                {targetEvent.receiver.name}
                            </p>

                            <p><b>Date</b></p>
                            <p><i>{convertDateFront(targetEvent.date)}</i></p>

                            {currentCallLogs !== undefined && currentCallLogs.length > 0 && (
                                <Fragment>
                                    <p><b>Call Log:</b></p>
                                    {currentCallLogs.map((item) => (
                                        <p key={item.id}>{item.notes}</p>
                                    ))}
                                </Fragment>
                            )}

                            <div className="text-center">
                                <Button
                                    color="info"
                                    className="mr-2"
                                    onClick={() => {
                                        if (setTriggerLogCall) {
                                            setGlobalGift(targetEvent);
                                            setTriggerLogCall(true);
                                        }
                                    }}
                                >
                                    Call / Log
                                </Button>

                                {targetEvent.status !== GiftStatuses.COMPLETED && (
                                    <Fragment>
                                        <Button
                                            color="secondary"
                                            className="mr-2"
                                            onClick={toggleModalEditMiddle}
                                        >
                                            Edit
                                        </Button>
                                        <Button
                                            color="danger"
                                            className="btn-small"
                                            onClick={toggleModalRemove}
                                        >
                                            Remove
                                        </Button>
                                    </Fragment>
                                )}

                                {targetEvent.status === GiftStatuses.COMPLETED && isEnabledEditCallLog && (
                                    <Fragment>
                                        <Button
                                            color="secondary"
                                            className="mr-2"
                                            onClick={() => {
                                                toggleModalEditLog();
                                            }}
                                        >
                                            Edit Call Log
                                        </Button>
                                    </Fragment>
                                )}
                                
                            </div>
                            
                            <Modal isOpen={modalEdit} toggle={toggleModalEdit}>
                                <ModalHeader toggle={toggleModalEdit}>
                                    Edit Event
                                </ModalHeader>
                                <ModalBody>
                                <FormGroup row>
                                    <Label for="receiver" sm={2}>
                                        Senior
                                    </Label>
                                    <Col sm={10}>
                                        <select
                                            className="form-control"
                                            defaultValue={targetEvent.receiver.id}
                                            onChange={(e) => {
                                                setEditReceiver(e.target.value);
                                            }}
                                        >
                                            {receivers &&
                                                receivers.map((receiver) => (
                                                    <option
                                                        value={receiver.id}
                                                        key={receiver.id}
                                                    >
                                                        {receiver.name}
                                                    </option>
                                                ))}
                                        </select>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label for="date" sm={2}>
                                        Date
                                    </Label>
                                    <Col sm={10}>
                                        <DatePicker
                                            selected={targetEvent.editDate}
                                            onChange={toggleEditDate}
                                            showTimeSelect
                                            className="form-control"
                                            timeFormat="p"
                                            timeIntervals={30}
                                            dateFormat="MMMM d, yyyy h:mm aa"
                                            timeCaption="Time"
                                        />
                                    </Col>
                                </FormGroup>
                                <div className="text-center">
                                    <Button
                                        className="btn-wide mb-2 mr-2"
                                        size="md"
                                        color="info"
                                        onClick={editEvent}
                                    >
                                        OK
                                    </Button>

                                    <Button
                                        className="btn-wide mb-2 mr-2"
                                        size="md"
                                        color="secondary"
                                        onClick={toggleModalEdit}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                                </ModalBody>
                            </Modal>

                            <Modal isOpen={modalRemove} toggle={toggleModalRemove}>
                                <ModalHeader toggle={toggleModalRemove}>
                                    Confirm Remove Event
                                </ModalHeader>
                                <ModalBody>
                                    <div className="text-center">
                                        <p>Do you really want to remove Event?</p>
                                        <Button
                                            className="btn-wide mb-2 mr-2"
                                            size="md"
                                            color="danger"
                                            onClick={removeEvent}
                                        >
                                            Remove
                                        </Button>

                                        <Button
                                            className="btn-wide mb-2 mr-2"
                                            size="md"
                                            color="secondary"
                                            onClick={toggleModalRemove}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </ModalBody>
                            </Modal>

                        </Fragment>
                    )}
                </ModalBody>
            </Modal>

            <ModalEditCallLogFromEvent
                modalEditLog={modalEditLog}
                toggleModalEditLog={toggleModalEditLog}
                targetEvent={targetEvent}
                toggleModalTargetEvent={toggleModalTargetEvent}
            />

        </Fragment>
    )
}
